export default __webpack_public_path__ + "static/media/lost-banner.13f5bbc2.png";